module.exports = {"name":"Aggregates","version":"1.0.0-SNAPSHOT","description":"","repository":{"type":"git","url":"cvtienhoven/graylog-plugin-aggregates"},"scripts":{"start":"./node_modules/.bin/webpack-dev-server","build":"./node_modules/.bin/webpack"},"keywords":["graylog"],"author":"Christiaan van Tienhoven <c_van_tienhoven@hotmail.com>","license":"MIT","dependencies":{"graylog-web-plugin":"file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"},"devDependencies":{"graylog-web-plugin":"file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 155
// module chunks = 0